import { optionSubcategory_accounts } from './accountsSubCategory.locstring.json';
import { ConnectedAccountsOption, initConnectedAccountsFull } from 'owa-connected-accounts-option';
import PopImapOption from 'owa-pop-imap-option/lib/PopImapOption';
import { OptionSubCategory } from 'owa-options-core';
import { trace } from 'owa-trace';
import { isFeatureEnabled } from 'owa-feature-flags';

const accountsSubCategory: OptionSubCategory = {
    key: 'accounts',
    titleStringKey: optionSubcategory_accounts,
    options: [ConnectedAccountsOption, PopImapOption],
    onSelected: () => {
        return loadAccountsConfiguration();
    },
};

async function loadAccountsConfiguration(): Promise<boolean> {
    try {
        if (isFeatureEnabled('auth-connectedAccounts')) {
            await initConnectedAccountsFull();
        }
        return true;
    } catch (e) {
        trace.warn(e.message);
        return false;
    }
}

export default accountsSubCategory;
